<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    :title="title"
    @hide="onDialogHide"
    @submit="onSubmit"
  >
    <div class="row q-col-gutter-md">
      <p class="col-12 q-ma-none">
        {{ subtitle }}
      </p>
      <div class="col-12">
        <client-users-selector
          v-model="selectedUser"
          :label="$t('sessions.modals.callInvite.inputParticipant')"
          :session-id="sessionId"
          :skip-users="skipUsers"
          skip-current-user
        />
      </div>
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonCancel')"
        @click="hide"
      />
      <hr-confirm-btn
        type="submit"
        :label="submitButtonLabelWithDefault"
        :disable="!selectedUser"
      />
    </template>
  </hr-form-dialog>
</template>

<script>
import ClientUsersSelector from 'components/UI/ClientUsersSelector';
import {
  HrConfirmBtn,
  HrDismissBtn,
  HrFormDialog,
} from 'src/design-system';

export default {
  name: 'InviteUser',

  components: {
    ClientUsersSelector,
    HrConfirmBtn,
    HrDismissBtn,
    HrFormDialog,
  },

  props: {
    submitButtonLabel: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      required: true,
    },

    subtitle: {
      type: String,
      required: true,
    },

    sessionId: {
      type: String,
      required: true,
    },

    skipUsers: {
      type: Array,
      required: true,
    },
  },

  emits: ['ok', 'hide'],

  data() {
    return {
      selectedUser: null,
    };
  },

  computed: {
    submitButtonLabelWithDefault() {
      return this.submitButtonLabel || this.$t('sessions.modals.callInvite.buttonSubmit');
    }, // submitButtonLabelWithDefault()
  },

  methods: {
    onSubmit() {
      this.$emit('ok', this.selectedUser);
      this.hide();
    },

    onDialogHide() {
      this.hide();
      this.$emit('hide');
    },

    show() {
      this.$refs.dialog.show();
    },

    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },
  },
};
</script>
